import { createStore } from "redux";
import { quoteReducer, initialState } from "./reducers";

const appCfg = require("./config");

let devToolsEnabled = appCfg.reduxDevTool && appCfg.reduxDevTool.enabled && window.__REDUX_DEVTOOLS_EXTENSION__;
// Passing {trace: false} doesn't seem to work...
let devToolsOptions = devToolsEnabled && appCfg.reduxDevTool.trace ? {trace: true} : {};

var store;

if (devToolsEnabled) {
    store = createStore(quoteReducer,
                        initialState(),
                        window.__REDUX_DEVTOOLS_EXTENSION__(devToolsOptions));
} else {
    store = createStore(quoteReducer,
                        initialState())
}

export default store;
